import { render, staticRenderFns } from "./ConsentsEdit.vue?vue&type=template&id=53897697&scoped=true"
import script from "./ConsentsEdit.vue?vue&type=script&lang=js"
export * from "./ConsentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53897697",
  null
  
)

export default component.exports